import React from 'react';
import { getLang, getTranslations } from '../../../../../translations';
import { Option } from '../../../../../types';
import { formatCurrency } from '../../../../../utils/format';
import PriceDetails from '../../PriceDetails';
import AdditionalOptionWrapper from './AdditionalOptionWrapper';

interface AccessoryPackageInterface {
    options : Option[] | null
}

const AccessoryPackage = ({ options }: AccessoryPackageInterface) => {
    const lang =getLang();
    const trans = getTranslations();
    return (
        <AdditionalOptionWrapper label={trans.details.details_packages + ':'}>
            {options?.map((opt, i) => {
                if (opt.price != null && Number(opt.price) !== 0 ) {
                    const key = `accessory-package-${i}`;
                    return <PriceDetails
                            key={key}
                            name={opt.description?.[lang] as string}
                            price={formatCurrency(Number(opt.price), true, lang)} bold={false} />
                }
                else {
                    return undefined;
                }
            })}
        </AdditionalOptionWrapper>
    );
}

export default AccessoryPackage;
